import { JsxElement, JsxElementType } from "./jsxElementTypes";

/**
 * Determines whether AI generation should be used for a JSX element based on the following logic:
 * - Use AI if the element is a storybook component type
 * - Do NOT use AI if the element has isTemplateStory set to true
 * - Do NOT use AI if the element has library property set
 *
 * @param element The JSX element to evaluate
 * @returns true if AI generation should be used, false otherwise
 */
export function shouldUseAiGeneration(element: JsxElement): boolean {
  // Only consider storybook component types for AI generation
  if (element.type !== JsxElementType.StorybookComponent) {
    return false;
  }

  // Do not use AI for template stories
  if (element.isTemplateStory) {
    return false;
  }

  // Do not use AI for library components
  if (element.library) {
    return false;
  }

  // Use AI for all other storybook components
  return true;
}

/**
 * Helper function to determine AI generation for elements that might be undefined/null
 */
export function shouldUseAiGenerationSafe(
  element?: JsxElement | null
): boolean {
  if (!element) {
    return false;
  }

  return shouldUseAiGeneration(element);
}
